module.exports = __webpack_public_path__ + "media/student_v2/assets/images/student-alert-chevron-right-d600d4da21a47b628d58688a52b03226.svg";